import { getSyncDefaultSearch } from '../../helpers/Common';
import reducerRegistry from '../../helpers/ReducerRegistry';
import { formatPercent, formatTextFloat } from './../../helpers/Text';
import priceDataService from './../../../core/services/Prices/PriceData/PriceDataService';
import snapShotService from '../../../core/services/Fundamental/SnapShotService';
import valuationToolService from '../../../core/services/Tools/Valuation/Valuation';
import Const from './Const';
import ConstCommon from './../../common/Const';
import currentState from './../../helpers/CurrentState';

const REDUCER_NAME = 'VALUATION:';
const CHANGE_CODE = `${REDUCER_NAME}CHANGE_CODE`;
const SUBSCRIBE_REALTIME_DATA_TICK = `${REDUCER_NAME}SUBSCRIBE_REALTIME_DATA_TICK`;
const FETCH_INFO_TICKER = `${REDUCER_NAME}FETCH_INFO_TICKER`;
const GET_COMPANY_SCORE = `${REDUCER_NAME}GET_COMPANY_SCORE`;
const CHANGE_YEAR_DROPDOW = `${REDUCER_NAME}CHANGE_YEAR_DROPDOW`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const CHANGE_AVERAGE_PE = `${REDUCER_NAME}CHANGE_AVERAGE_PE`;
const GET_VALUATION_TOOL = `${REDUCER_NAME}GET_VALUATION_TOOL`;
const CHANGE_AVERAGE_PB = `${REDUCER_NAME}CHANGE_AVERAGE_PB`;
const CHANGE_AVERAGE_FCFE = `${REDUCER_NAME}CHANGE_AVERAGE_FCFE`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const SET_LOADING = `${REDUCER_NAME}SET_LOADING`;

export {
  REDUCER_NAME,
  reducer as default,
  subscribeRealtimeTick,
  changeCode,
  fetchInfoTicker,
  fetchCompanyScore,
  changeYearDropdow,
  getAveragePE,
  fetchValuationTool,
  getAveragePB,
  getAverageFCFE,
};

function setLoading(isLoading) {
  return dispatch => {
    dispatch({
      type: SET_LOADING,
      payload: {
        isLoading,
      },
    });
  };
}

//realtime
function subscribeRealtimeTick(data) {
  return {
    type: SUBSCRIBE_REALTIME_DATA_TICK,
    payload: {
      result: data,
    },
  };
}

//search
function changeCode(currentSearch) {
  return dispatch => {
    dispatch(setLoading(true));
    dispatch({
      type: CHANGE_CODE,
      payload: {
        currentSearch,
      },
    });
    const promises = [
      dispatch(fetchInfoTicker()),
      dispatch(fetchCompanyScore()),
      dispatch(fetchValuationTool()),
    ];
    Promise.all(promises).then(() => {
      dispatch(setLoading(false));
    });
  };
}

function fetchInfoTicker() {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      const currentSearch = getState()[REDUCER_NAME].currentSearch;
      const code = currentSearch.code;
      priceDataService.getLatestPrice({ Code: code }).then(response => {
        let tickerInfomation = {};
        if (response.items) {
          tickerInfomation = response.items[0];
        }
        dispatch({
          type: FETCH_INFO_TICKER,
          payload: {
            infoTicker: tickerInfomation,
          },
        });
        resolve(true);
      });
    });
  };
}

function fetchCompanyScore() {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      const code = getState()[REDUCER_NAME].currentSearch.code;
      snapShotService.getCompanyScore({ OrganCode: code }).then(response => {
        const { items = [] } = response;
        dispatch({
          type: GET_COMPANY_SCORE,
          payload: {
            companyScore: items && items.length ? items[0] : {},
          },
        });
        resolve(true);
      });
    });
  };
}

function fetchValuationTool() {
  console.log(1111);
  return (dispatch, getState) => {
    return new Promise(resolve => {
      const code = getState()[REDUCER_NAME].currentSearch.code;
      valuationToolService.getValuation({ OrganCode: code }).then(response => {
        if (response.items) {
          dispatch({
            type: GET_VALUATION_TOOL,
            payload: {
              data: response.items,
            },
          });
        }
        resolve(true);
      });
    });
  };
}

function changeYearDropdow(year) {
  return dispatch => {
    dispatch({
      type: CHANGE_YEAR_DROPDOW,
      payload: {
        year,
      },
    });
  };
}

function getAveragePE(value) {
  return dispatch => {
    dispatch({
      type: CHANGE_AVERAGE_PE,
      payload: {
        value,
      },
    });
  };
}

function getAveragePB(value) {
  return dispatch => {
    dispatch({
      type: CHANGE_AVERAGE_PB,
      payload: {
        value,
      },
    });
  };
}

function getAverageFCFE(value) {
  return dispatch => {
    dispatch({
      type: CHANGE_AVERAGE_FCFE,
      payload: {
        value,
      },
    });
  };
}

const initialState = {
  indexSumary: {},
  indexSumaryRealTime: {},
  companyScore: {},
  yearDropDow: Const.defaultYearSelect,
  component: {},
  averagePE: null,
  averagePB: null,
  averageFCFE: null,
  valuationSector: {},
  valuationStock: {},
  isLoading: false,
};

function reducer(state = {}, action) {
  switch (action.type) {
    case SET_LOADING:
      const { isLoading } = action.payload;
      return {
        ...state,
        isLoading,
      };

    case INIT_COMPONENT:
      const { dragCode } = action.payload;

      const currentSearch = dragCode ||
        currentState.get(
          ConstCommon.listComponent.Valuation,
          'currentSearch',
        ) ||
        getSyncDefaultSearch(ConstCommon.listComponent.Valuation, true) || {
          code: 'AAA',
          displayCode: 'AAA',
        };

      return {
        ...state,
        ...initialState,
        currentSearch,
      };

    case UNMOUNT_COMPONENT:
      return {};

    case GET_VALUATION_TOOL:
      const data = action.payload.data;

      const { valuationStock = {}, valuationSector = {} } =
        data.length > 0 ? data[0] : {};

      return {
        ...state,
        valuationSector,
        valuationStock,
        averageFCFE: formatTextFloat(
          +formatPercent(valuationStock.riskFreeRate) +
            +formatTextFloat(valuationStock.rtd35) *
              +formatPercent(valuationStock.vnIndexEquityRisk),
        ),
      };

    case SUBSCRIBE_REALTIME_DATA_TICK:
      const { result: resultTick } = action.payload;
      if (resultTick) {
        return {
          ...state,
          indexSumaryRealTime: resultTick,
        };
      }
      return state;

    case GET_COMPANY_SCORE:
      const { companyScore } = action.payload;
      return {
        ...state,
        companyScore,
      };

    case FETCH_INFO_TICKER:
      const { infoTicker } = action.payload;

      let indexSumary = {};
      if (Object.keys(infoTicker).length) {
        indexSumary = infoTicker.priceInfo || {};
      }

      return {
        ...state,
        indexSumary,
      };

    case CHANGE_CODE: {
      const { currentSearch } = action.payload;

      currentState.add(ConstCommon.listComponent.Valuation, 'currentSearch', {
        code: currentSearch.code,
        displayCode: currentSearch.displayCode,
      });

      return {
        ...state,
        currentSearch,
        averagePE: null,
        averagePB: null,
        averageFCFE: null,
      };
    }

    case CHANGE_YEAR_DROPDOW:
      const { year } = action.payload;
      return {
        ...state,
        yearDropDow: year,
      };

    case CHANGE_SIZE_COMPONENT:
      return {
        ...state,
        component: action.payload,
      };

    case CHANGE_AVERAGE_PE:
      return {
        ...state,
        averagePE: action.payload.value,
      };

    case CHANGE_AVERAGE_PB:
      return {
        ...state,
        averagePB: action.payload.value,
      };

    case CHANGE_AVERAGE_FCFE:
      return {
        ...state,
        averageFCFE: action.payload.value,
      };

    default:
      return state;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
